import React, { useState } from "react";
import { LinkIcon } from "@heroicons/react/24/outline";
import "./CopyLinkButton.css";

interface CopyLinkButtonProps {
    link: string;
    className?: string;
}

const CopyLinkButton: React.FC<CopyLinkButtonProps> = ({ link, className = '' }) => {
    const [copySuccess, setCopySuccess] = useState<boolean>(false);

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(link);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
        } catch (err) {
            console.error('Failed to copy link:', err);
        }
    };

    return (
        <button 
            className={`CopyLinkButton ${copySuccess ? 'success' : ''} ${className}`}
            onClick={handleCopyLink}
            title={copySuccess ? "Lien copié !" : "Copier le lien"}
        >
            <LinkIcon />
            {copySuccess && (
                <span className="CopyLinkButton-feedback">Copié !</span>
            )}
        </button>
    );
};

export default CopyLinkButton;

